import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@abb/uikit';
import React from 'react';
function NotificationLogoIcon(props) {
    const { size = 18 } = props;
    return /*#__PURE__*/ _jsxs(Icon, {
        className: "ibaicon",
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.42019 8.00024C2.59731 6.6696 2.15686 5.09515 2.45287 3.49998C2.55386 2.95588 2.99045 2.53318 3.53712 2.44709C4.02622 2.37001 4.37977 2.3314 5.07255 2.38897C4.82289 2.80345 4.67519 3.21684 4.51987 3.6186C4.17384 3.60602 3.82133 3.67525 3.70968 3.70968C3.42851 4.74894 3.79133 6.52821 4.88746 8.00024H3.42019Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.76135 4.76154C5.1204 3.23876 5.92227 1.81398 7.25952 0.895361C7.71569 0.582004 8.3233 0.591867 8.77075 0.917508C9.17108 1.20886 9.44836 1.43158 9.89757 1.96215C9.42794 2.07868 9.03116 2.26656 8.63725 2.44084C8.40144 2.18725 8.10326 1.98694 7.99994 1.93234C7.06628 2.46838 6.06468 3.98313 5.79888 5.79907L4.76135 4.76154Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.99994 3.42014C9.33062 2.59726 10.905 2.15678 12.5002 2.45279C13.0443 2.55377 13.467 2.99037 13.5531 3.53704C13.6302 4.02614 13.6688 4.37968 13.6113 5.07251C13.1968 4.82284 12.7834 4.67515 12.3816 4.51979C12.3942 4.1738 12.325 3.82128 12.2905 3.70963C11.2512 3.42847 9.47194 3.79129 7.99994 4.88741V3.42014Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.2385 4.76149C12.7612 5.12053 14.186 5.92237 15.1046 7.25965C15.418 7.71579 15.4081 8.3234 15.0825 8.77089C14.7911 9.17122 14.5684 9.4485 14.0378 9.89771C13.9213 9.42807 13.7334 9.0313 13.5592 8.63738C13.8127 8.40158 14.013 8.1034 14.0677 8.00007C13.5316 7.06638 12.0169 6.06482 10.2009 5.79902L11.2385 4.76149Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.58 7.99998C13.4029 9.33063 13.8433 10.9051 13.5473 12.5002C13.4463 13.0444 13.0097 13.467 12.463 13.5532C11.9739 13.6302 11.6204 13.6689 10.9276 13.6113C11.1772 13.1968 11.3249 12.7834 11.4803 12.3816C11.8263 12.3942 12.1788 12.325 12.2905 12.2906C12.5716 11.2513 12.2088 9.47201 11.1127 7.99998H12.58Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.2387 11.2386C10.8796 12.7614 10.0778 14.1861 8.74049 15.1048C8.28435 15.4182 7.67674 15.4083 7.22929 15.0827C6.82896 14.7913 6.55169 14.5686 6.10248 14.038C6.57211 13.9214 6.96885 13.7336 7.36276 13.5593C7.59861 13.8129 7.89678 14.0132 8.00011 14.0678C8.93376 13.5317 9.93536 12.017 10.2012 10.2011L11.2387 11.2386Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.00003 12.5802C6.66935 13.4031 5.09494 13.8435 3.49977 13.5476C2.95563 13.4466 2.53297 13.01 2.44684 12.4633C2.3698 11.9742 2.33115 11.6206 2.38872 10.9279C2.80324 11.1775 3.21659 11.3252 3.61835 11.4805C3.60581 11.8266 3.67504 12.1791 3.70947 12.2907C4.74873 12.5719 6.528 12.2091 8.00003 11.1129V12.5802Z",
                fill: "#1D6FB6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.76156 11.2388C3.23878 10.8797 1.81404 10.0779 0.895384 8.7406C0.582027 8.28447 0.59189 7.67682 0.917567 7.22937C1.20889 6.82904 1.4316 6.55176 1.96221 6.10255C2.07874 6.57219 2.26659 6.96896 2.44086 7.36287C2.18728 7.59868 1.987 7.89686 1.93237 8.00019C2.4684 8.93388 3.98316 9.93544 5.79909 10.2012L4.76156 11.2388Z",
                fill: "#1D6FB6"
            })
        ]
    });
}
export default NotificationLogoIcon;
